import { render, staticRenderFns } from "./AssignTypeFields.vue?vue&type=template&id=4a768e49&scoped=true&"
import script from "./AssignTypeFields.vue?vue&type=script&lang=js&"
export * from "./AssignTypeFields.vue?vue&type=script&lang=js&"
import style0 from "./AssignTypeFields.vue?vue&type=style&index=0&id=4a768e49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a768e49",
  null
  
)

export default component.exports